import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { createFileRoute } from "@tanstack/react-router";
import type { RoutineFormProps } from "@/components/forms/RoutineForm";
import { RoutineForm } from "@/components/forms/RoutineForm";
import { ManageResource } from "@/components/resources/ManageResource";
import { useMobile } from "@/providers/mobileProvider";
import { useMobileNavbar } from "@/providers/mobileNavbarProvider";
import { Container } from "@/components/ui/container";
import { getResourceInfo } from "@/utilities/getResourceInfo";
import { SCHEMA_NAMES } from "instantdb/types";
import { NotFound } from "@/not-found";
import { GlobalError } from "@/global-error";
import { useTranslation } from "@/hooks/useTranslation";

export const Route = createFileRoute("/dashboard/routine/manage")({
  component: RoutineManagePage,
  notFoundComponent: NotFound,
  errorComponent: GlobalError,
});

function RoutineManagePage() {
  const { atom } = getResourceInfo(SCHEMA_NAMES.routines);
  const managedAtom = useAtomValue(atom);
  const { isMobile } = useMobile();
  const { setMobileNavbar } = useMobileNavbar();
  const { t } = useTranslation();

  // Set up navbar configuration
  useEffect(() => {
    if (isMobile) {
      setMobileNavbar({
        title:
          managedAtom.mode === "create"
            ? t("manage_routine.add_title")
            : t("manage_routine.edit_title"),
        showBackButton: true,
      });
    }
  }, [isMobile, setMobileNavbar, managedAtom.mode]);

  return (
    <Container className="col-span-12 @[800px]:col-span-8 @[800px]:col-start-3 @[1200px]:col-span-6 @[1200px]:col-start-4">
      <ManageResource
        slug={SCHEMA_NAMES.routines}
        Form={<RoutineForm {...({} as RoutineFormProps)} />}
        isMobilePath
      />
    </Container>
  );
}
